import React, { useContext, useState, useEffect } from "react";
import {
  Tab,
  Form,
  FormGroup,
  Input,
  TextArea,
  Grid,
  Label,
  Container
} from "semantic-ui-react";
//import WorkOrderStore from "../../../../app/stores/workorderStore";
import UserAuthStore from "../../../../app/stores/userauthStore"
import { observer } from "mobx-react-lite";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderSORSGrid from "../wo_sor_grid/WorkOrderSORSGridOne";
import WorkOrderEngineerNotes from "../wo_engineer_notes/WorkOrderEngineerNotes";
import WorkOrderVarHistory from "../wo_varhistory/WorkOrderVarHistoryOne";
import WorkOrderVariations from "../wo_variations/WorkOrderVariations";
import AppointmentGrid from "../wo_appointments/AppointmentGridOne";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import LewishamDocuments from "../lewisham/LewishamDocuments"
import workorderStore from "../../../../app/stores/workorderStore";

//ADD 230608 - check document tab
import WorkOrderDocumentGrid from "../wo_document_grid/WorkOrderDocumentGrid";
//ADD230614 - check clientnote tab
import WorkOrderClientnoteGrid from "../wo_clientnote_grid/WorkOrderClientnoteGrid";
import WorkOrderEngineerNotesOne from "../wo_engineer_notes/WorkOrderEngineerNotesOne";


interface IProps {}
const getWoClaim = (cause,value) => {
  console.log("cause = " + cause)
  console.log("value = " + value)

  if(cause == "PPP"){
    console.log("ppp");
    return value - 500;
  }else{
    console.log("not ppp");
    return 0;
  }
}

const getPanes = (wo: IWorkorder) => {
console.log("PANES GETTING")
    return [
      {
        menuItem: "Details",
        render: () => (
          <Tab.Pane attached={false}>
            <Container>             
              <Grid>             
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Form widths="equal">
                      <FormGroup>
                        <Form.Field>
                          <Input
                            value={wo.JobNo}
                            label="Job No"
                            size="mini"
                            readOnly
                            placeholder="Job No"
                            fluid
                          />
                        </Form.Field>
                        <Form.Field>
                          <Input
                            value={wo.ClientRef}
                            label="Client Ref"
                            size="mini"
                            readOnly
                            placeholder="Client Ref"
                            fluid
                          />
                        </Form.Field>
                      </FormGroup>
                      <Form.Field>
                          <Input
                            value={wo.JobSubStatus}
                            label="Sub Status"
                            size="mini"
                            readOnly
                            placeholder="Sub Status"
                            fluid
                          />
                        </Form.Field>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Prioritys"
                            value={wo.Priority}
                            size="mini"
                            readOnly
                            placeholder="Priority"
                            fluid
                          />
                        </Form.Field>
                        <Form.Field>
                          <Input
                            fluid
                            label="Value"
                            readOnly
                            size="mini"
                            value={wo.JobValue}
                            placeholder="Value"
                          />
                        </Form.Field>
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Cause"
                            value={wo.Cause}
                            size="mini"
                            readOnly
                            placeholder="Cause"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Date Raised"
                            value={wo.DateRaised}
                            size="mini"
                            readOnly
                            placeholder="Date Raised"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                      
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="WO Claim"
                            value={getWoClaim(wo.Cause,wo.JobValue)}
                            size="mini"
                            readOnly
                            placeholder="Claim"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Label>Site Address</Label>
                          <TextArea readOnly value={wo.Address} />
                        </Form.Field>
                      </FormGroup>
                    </Form>
                  </Grid.Column>
                  <Grid.Column>
                    <Form widths="equal">
                      <FormGroup>
                        <Form.Field>
                          <Label>Job Summary</Label>
                          <TextArea readOnly rows="10" value={wo.JobSummary} />
                        </Form.Field>
                      </FormGroup>
                      <FormGroup>
                        <Form.Field>
                          <Input
                            label="Job Created On"
                            value={wo.CreatedOn}
                            size="mini"
                            readOnly
                            placeholder="Job Create On"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                    </Form>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Tab.Pane>
        )
      },
      {
        menuItem: "SORS",
        render: () => (
          <Tab.Pane attached={false}>
            <WorkOrderSORSGrid />
          </Tab.Pane>
        )
      },
      {
        menuItem: "Variation History",
        render: () => (
          <Tab.Pane attached={false}>
            <WorkOrderVarHistory />
          </Tab.Pane>
        )
      },
      {
        menuItem: "Appointments",
        render: () => (
          <Tab.Pane attached={false}>
            <AppointmentGrid/>
          </Tab.Pane>
        )
      },
      
    ]
  } 

const panes = [
  {
    menuItem: "Details",
    render: () => (
      <Tab.Pane attached={false}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Job No"
                      size="mini"
                      placeholder="Job No"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Client Ref"
                      size="mini"
                      placeholder="Client Ref"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>

                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Status"
                      size="mini"
                      placeholder="Status"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Sub Status"
                      size="mini"
                      placeholder="Sub Status"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Priority"
                      size="mini"
                      placeholder="Priority"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      fluid
                      label="Value"
                      size="mini"
                      placeholder="Value"
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Label>Site Address</Label>
                    <TextArea />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Label>Job Summary</Label>
                    <TextArea rows="10" />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    )
  },
  {
    menuItem: "SORS",
    render: () => <Tab.Pane attached={false}>SORS</Tab.Pane>
  },
  {
    menuItem: "Engineer Notes",
    render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
  },
  {
    menuItem: "Variation History",
    render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
  },

  {
    menuItem: "Appointments",
    render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
  },

  
];
const lewishamMOTPanes = [
  {
    menuItem: "Details",
    render: () => (
      <Tab.Pane attached={false}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Job No"
                      size="mini"
                      placeholder="Job No"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Client Ref"
                      size="mini"
                      placeholder="Client Ref"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>

                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Status"
                      size="mini"
                      placeholder="Status"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Sub Status"
                      size="mini"
                      placeholder="Sub Status"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Priority"
                      size="mini"
                      placeholder="Priority"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      fluid
                      label="Value"
                      size="mini"
                      placeholder="Value"
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Label>Site Address</Label>
                    <TextArea />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Label>Job Summary</Label>
                    <TextArea rows="10" />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    )
  },
  {
    menuItem: "SORS",
    render: () => <Tab.Pane attached={false}>SORS</Tab.Pane>
  },
  {
    menuItem: "Engineer Notes",
    render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
  },
  {
    menuItem: "Variation History",
    render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
  },

  {
    menuItem: "Appointments",
    render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
  },
 

 
  
];
//ADD 230608 for origin document tab
const getOriginPanes = (wo: IWorkorder) => {
  var OriginPanes = getPanes(wo)
  OriginPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
    )
    });
    OriginPanes.push({
      menuItem: "Notes",
      render: () => (
         <Tab.Pane attached={false}><WorkOrderClientnoteGrid  /></Tab.Pane>
      )
      });   
      OriginPanes.push({
        menuItem: "Engineer Notes",
        render: () => (
          <Tab.Pane attached={false}>
            <WorkOrderEngineerNotesOne />
          </Tab.Pane>
        )
      },);    
    
  return OriginPanes;
  };

//ADD 251023 for peabody document tab
const getPeabodyPanes = (wo: IWorkorder) => {
  var PeabodyPanes = getPanes(wo)
  PeabodyPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
    )
    });
    
  return PeabodyPanes;
  };


//ADD 230608 for origin document tab
var OriginPanes = panes
OriginPanes.push({
  menuItem: "Documents",
  render: () => <Tab.Pane attached={false}>Documents</Tab.Pane>
});
OriginPanes.push({
  menuItem: "Notes",
  render: () => <Tab.Pane attached={false}>Notes</Tab.Pane>
});
// OriginPanes.push({
//   menuItem: "Engineer Notes",
//     render: () => <Tab.Pane attached={false}><WorkOrderEngineerNotesOne/>
//     </Tab.Pane>
// }); 

//ADD 251023 for peabody document tab
const PeabodyPanes = panes

const WorkOrderDetails: React.FC<IProps> = (props) => {
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

  const userauthStore = useContext(UserAuthStore);
  const workorderStore = useContext(oneOrderStore);

  const { selectedWorkOrder: workorder } = workorderStore;
  const [tabContent, setTabContent] = useState([{}]);

  useEffect(() => {
    console.log(workorder)
   }, [workorder]);

  useEffect(() => {
    userauthStore.HydrateAuthState();
   }, [userauthStore]);
 

  useEffect(() => {

    var cli = sessionObj.Client.Name;
    console.log('client>>',cli )
    if (workorder != null) 
    {
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        console.log('workorder>>',workorder)
        setTabContent(getOriginPanes(workorder));
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        setTabContent(getPeabodyPanes(workorder))
      } else{
        setTabContent(getPanes(workorder));
      }
    } 
    else
    {
      //CHANGE 251023 for peabody document tab
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        setTabContent(OriginPanes)
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        setTabContent(PeabodyPanes)
      } else if(cli == "Lewisham MOT"){
        setTabContent(lewishamMOTPanes)
      } else {
        setTabContent(panes)
      }
    }
  }, [workorder]);

  return (
    <div>
      <Tab
        menu={{ fluid: true, vertical: true, tabular: false }}
        panes={tabContent}
      />
    </div>
  );
};

export default observer(WorkOrderDetails);
